import { createContext, useContext } from "react";

/**
 * Canal de alertas do cabeçalho.
 *
 * O `AppLayout` é partilhado por todos os perfis, por isso não sabe — nem deve
 * saber — de onde vêm os alertas. Quem tiver alertas para mostrar embrulha o
 * layout num provedor; quem não tiver deixa o contexto a `null` e o sino fica
 * silencioso, sem indicador falso.
 *
 * Forma esperada:
 *   { items: [{ id, title, subtitle, urgent }], total, onOpen(item), onOpenAll() }
 */
export const AlertsContext = createContext(null);

export const useAlerts = () => useContext(AlertsContext);
